import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { ListItem, ListItemButton, ListItemIcon, Tooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import NotificationCountBadge from 'components/NotificationsBadge';
import { authActions } from 'features/Auth/authSlice';

import { RootState } from '../../store';
import { MenuItem } from '../SideBar/types';
interface SideBarlistProps {
  active?: boolean;
  menuItem: MenuItem;
  handleClick: (menuItem: MenuItem) => void;
  unsavedDataAction: (url: string) => void;
  unsavedData?: boolean;
}

export default function SideBarList({
  active = false,
  menuItem,
  handleClick,
  unsavedDataAction,
  unsavedData,
}: SideBarlistProps) {
  const dispatch = useDispatch();
  const { user } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();
  const theme = useTheme();
  const MenuIcon = menuItem.Icon;

  const handleMenuClick = (item: MenuItem) => {
    const path = `/${item.label.toLowerCase()}`;
    if (unsavedData) {
      return unsavedDataAction(path);
    }

    handleClick(item);
    if (!item.drawer) {
      if (item.label === 'LOGOUT') {
        dispatch(authActions.resetCredentials());
      }
      navigate(path);
      return;
    }
  };

  return (
    <>
      <ListItem key={menuItem.label} disablePadding sx={{ display: 'block' }}>
        {menuItem.label === 'NOTIFICATIONS' && <NotificationCountBadge />}
        <ListItemButton
          id={`id-${menuItem.label}`}
          aria-haspopup="true"
          onClick={() => handleMenuClick(menuItem)}
          sx={{
            minHeight: 48,
            justifyContent: 'center',
            px: 2.5,
          }}>
          <ListItemIcon
            sx={{
              justifyContent: 'center',
              color: active ? theme.palette.primary.contrastText : theme.palette.primary.light,
              ':hover': {
                color: theme.palette.primary.contrastText,
              },
            }}>
            <Tooltip title={menuItem.label === 'ACCOUNT' ? user?.full_name : menuItem.label} placement="right">
              <MenuIcon />
            </Tooltip>
          </ListItemIcon>
        </ListItemButton>
      </ListItem>
    </>
  );
}
